import styles from './Sectiontitle.module.css'

export type SectiontitleProps = {
  title?: string
  subtitle?: any
  variant?:
    | 'primary'
    | 'secondary'
    | 'tertiary'
    | 'quaternary'
    | 'quinary'
    | 'insights'
    | 'reports'
    | 'podcasts'
  variantAlign?: 'center' | 'right' | 'left'
  variantBold?: boolean
}

export const PhnxSectiontitle: React.FC<SectiontitleProps> = ({
  title,
  subtitle,
  variant = 'primary',
  variantAlign = 'center',
  variantBold = false,
}) => {
  let sectionTitleClass = `${styles['sectiontitle']} ${styles[`variant-${variant}`]} ${styles[`variantAlign-${variantAlign}`]}`
  return (
    <div className={sectionTitleClass}>
      {variant === 'quaternary' ? (
        <>
          {title && title !== '' && (
            <div className={`title ${styles['sectiontitle-title']}`}>{title}</div>
          )}
          {subtitle && subtitle !== '' && variantBold === true && (
            <h2 className={`subtitle ${styles['sectiontitle-subtitle']}  ${styles['title-bold']}`}>
              {subtitle}
            </h2>
          )}
          {subtitle && subtitle !== '' && variantBold === false && (
            <h2 className={`subtitle ${styles['sectiontitle-subtitle']}`}>{subtitle}</h2>
          )}
        </>
      ) : variant === 'primary' ? (
        <>
          {title && title !== '' && variantBold === true && (
            <h2 className={`${styles['sectiontitle-title']} ${styles['title-bold']}`}>{title}</h2>
          )}
          {title && title !== '' && variantBold === false && (
            <h2 className={`${styles['sectiontitle-title']}`}>{title}</h2>
          )}
          {subtitle && subtitle !== '' && (
            <h3>
              <b>{subtitle}</b>
            </h3>
          )}
        </>
      ) : (
        <>
          {title && title !== '' && variantBold === true && (
            <h2 className={`${styles['sectiontitle-title']} ${styles['title-bold']}`}>{title}</h2>
          )}
          {title && title !== '' && <h2 className={`${styles['sectiontitle-title']}`}>{title}</h2>}
          {subtitle && subtitle !== '' && (
            <p className={`${styles['sectiontitle-subtitle']}`}>{subtitle}</p>
          )}
        </>
      )}
    </div>
  )
}
